import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { additionalImages } from '../data/mock';

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-24 bg-[#0f172a]">
      <div className="container mx-auto px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="heading-2 text-[#60a5fa] mb-4">{t.about.title}</h2>
            <p className="body-large text-[#94a3b8] mb-6">{t.about.subtitle}</p>
            <p className="body-medium text-[#94a3b8] leading-relaxed max-w-3xl mx-auto">
              {t.about.description}
            </p>
          </div>

          {/* Statistics */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16 mb-16">
            {t.about.stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="heading-1 text-[#60a5fa] mb-2">{stat.number}</div>
                <p className="caption text-[#94a3b8]">{stat.label}</p>
              </div>
            ))}
          </div>

          {/* Additional Image Showcase */}
          <div className="mt-12">
            <div className="relative overflow-hidden rounded-lg border border-[#1e40af] group">
              <img
                src={additionalImages.roofingWork}
                alt="Charter Roofings Professional Work"
                className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
